import { useMemo } from "react";
import PropTypes from "prop-types";
import Lomake from "@/components/02-organisms/Lomake";
import { useChangeObjectsByAnchorWithoutUnderRemoval } from "@/stores/muutokset";
import { useIntl } from "react-intl";
import common from "@/i18n/definitions/common";

const constants = {
  formLocation: ["ammatillinenKoulutus", "muut", "yhteistyo"]
};

const Yhteistyo = ({
  isReadOnly,
  items,
  maarayksetByKoodiarvo,
  mode,
  sectionId
}) => {
  const { formatMessage } = useIntl();
  const [changeObjects] = useChangeObjectsByAnchorWithoutUnderRemoval({
    anchor: sectionId
  });
  const dataLomakepalvelulle = useMemo(
    () => ({
      items,
      maarayksetByKoodiarvo
    }),
    [items, maarayksetByKoodiarvo]
  );

  return (
    <Lomake
      anchor={sectionId}
      changeObjects={changeObjects}
      data={dataLomakepalvelulle}
      isReadOnly={isReadOnly}
      mode={mode}
      path={constants.formLocation}
      rowTitle={formatMessage(common.yhteistyovelvoitteet)}
      showCategoryTitles={true}
    />
  );
};

Yhteistyo.propTypes = {
  isReadOnly: PropTypes.bool,
  items: PropTypes.array,
  maarayksetByKoodiarvo: PropTypes.object,
  mode: PropTypes.string,
  sectionId: PropTypes.string
};

export default Yhteistyo;
